import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function () {
    const thumbsSlider = new Swiper(".clients__thumbs.swiper", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
    });

    const mainSlider = new Swiper(".clients__main.swiper", {
        spaceBetween: 10,
        loop: true,
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-button-next",
        },
        pagination: {
            el: ".swiper-pagination",
        },
        thumbs: {
            swiper: thumbsSlider,
        },
    });
});
